import { Event } from '../interfaces';
import { CalibrationType } from '../interfaces/homography';
import { isMultiCameraSystem } from '../utils';

const HomographyFilenames: Record<CalibrationType, string> = {
  [CalibrationType.LPR]: 'homography-day.kml',
  [CalibrationType.NIGHTLPR]: 'homography-night.kml',
  [CalibrationType.MAP]: 'camera_gps_homography.yml',
};

export const getHomographyFilename = (type: CalibrationType, event?: Event): string => {
  if (!event) {
    return HomographyFilenames[type];
  }

  const isMulticamSystem = isMultiCameraSystem(event);

  if (isMulticamSystem) {
    const contextIndex = event.metadata?.context_camera_idx ?? 1;
    const lprIndex = event.metadata?.lpr_camera_idx ?? 1;

    if (type === CalibrationType.LPR) {
      return `homography-day-ctx${contextIndex}-lpr${lprIndex}.kml`;
    }
    if (type === CalibrationType.NIGHTLPR) {
      return `homography-night-ctx${contextIndex}-lpr${lprIndex}.kml`;
    }
  }

  return HomographyFilenames[type];
};
